import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import ClockIcon from "@dcl/icons/esm/ui/clock";

var Duration = function Duration(_ref) {
  var children = _ref.children,
      duration = _ref.duration;
  var getClassName = getClassNameFactory(Duration.displayName);
  return /*#__PURE__*/React.createElement("time", {
    className: getClassName(),
    dateTime: duration
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(ClockIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "text"
    })
  }, children));
};

Duration.displayName = "Duration";
export default Duration;